import ReactDOM from 'react-dom/client';

import App from './App';
import './assets/i18n/config';
import { installChunkErrorReload } from './routing/lazy/reloadOnChunkError';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './theme/fonts.css';
import './trusted-security-policies';

installChunkErrorReload();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <>
    <meta name='viewport' content='width=device-width, initial-scale=1.0' />
    <link
      rel='stylesheet'
      href='https://fonts.googleapis.com/icon?family=Material+Icons'
    />
    <App />
  </>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
